<template>
  <select
    class="frm-select frm-size-ss mr-3 ml-5"
    :value="modelValue"
    :disabled="disabled"
    @change="changeSelect"
  >
    <option
      v-if="disabledSelectedItem && !['', undefined, null].includes(disabledSelectedItem.code)"
      :value="disabledSelectedItem.code"
      hidden
      disabled
    >
      {{ disabledSelectedItem.text }}
    </option>
    <option
      v-for="item in itemList"
      :key="unique + item.code"
      :value="item.code"
    >
      {{ item.text }}
    </option>
  </select>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, watch } from "vue";
import { v4 as uuidv4 } from "uuid";
const props = defineProps({
  modelValue: {
    required: true,
    default: false,
  },
  disabled: {
    required: true,
    default: false,
  },
  itemList: {
    required: true,
    default: () => {
      return [];
    },
  },
  disabledSelectedItem: {
    required: true,
    default: () => {
      return { code: 0, text: '' };
    },
  },
  defaultIndex: {
    default: 0
  },
});
const emit = defineEmits(["update:modelValue"]);
const changeSelect = (e) => {
  const value = e.target.value;
  emit("update:modelValue", value);
};
let backup = "";
onMounted(() => {
  if (props.itemList.length > props.defaultIndex) {
    backup = props.itemList[props.defaultIndex].code;
  } else if (
    props.disabledSelectedItem &&
    !["", undefined, null].includes(props.disabledSelectedItem.code)
  ) {
    backup = props.disabledSelectedItem.code;
  }
});
watch(
  () => props.disabled,
  (val) => {
    if (val) {
      backup = props.modelValue;
      if (
        props.disabledSelectedItem &&
        !["", undefined, null].includes(props.disabledSelectedItem.code)
      ) {
        emit("update:modelValue", props.disabledSelectedItem.code);
      } else {
        emit("update:modelValue", props.itemList[props.defaultIndex].code);
      }
    } else {
      emit("update:modelValue", backup);
    }
  }
);

// unique
const unique = uuidv4();
</script>
